"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var ConfigProvider_1 = require("../../ConfigProvider");
var Portal_1 = tslib_1.__importDefault(require("../Portal"));
var utils_1 = require("../../utils");
function Mask(props) {
    var onClick = props.onClick, _a = props.autoDestroy, autoDestroy = _a === void 0 ? false : _a, _b = props.visible, visible = _b === void 0 ? false : _b, children = props.children, className = props.className, rest = tslib_1.__rest(props, ["onClick", "autoDestroy", "visible", "children", "className"]);
    var prefix = ConfigProvider_1.usePrefix('mask');
    var classname = classnames_1.default(prefix, visible && utils_1.concat(prefix, 'visible'), className);
    if (autoDestroy && visible === false) {
        return null;
    }
    return (react_1.default.createElement(Portal_1.default, null,
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", tslib_1.__assign({}, rest, { className: classname, onClick: onClick })),
            children)));
}
exports.default = Mask;
//# sourceMappingURL=index.js.map